var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Axios from './axios';
import { SEARCH, NURSURY, PLANTS, NURSERY_SEARCH, REQUEST_PLANT, NEWSLETTER_SUBSCRIBE, FEATURE, INDEX_DATA, COMMON_DATA, NAVIGATION_DATA, ADD_ITEMS, CART_CONTENTS, CLEAR_CART, HOMEPAGE, } from '../actions/constats';
import { getCookie } from '../utils/helpers';
var verifyCsrfExists = function () { return __awaiter(void 0, void 0, void 0, function () {
    var cookie;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                cookie = getCookie('csrftoken');
                if (!(cookie === '')) return [3 /*break*/, 2];
                return [4 /*yield*/, Axios.get(HOMEPAGE)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
export default {
    home: {
        getIndexData: function () { return Axios.get(INDEX_DATA); },
        getCommonData: function () { return Axios.get(COMMON_DATA); },
        getNavigationData: function () { return Axios.get(NAVIGATION_DATA); },
        generalSearch: function (slug) { return Axios.get(SEARCH + slug); },
        getAny: function (url) { return Axios.get(url); },
    },
    nursery: {
        updateSearchResult: function (query) { return Axios.get(NURSERY_SEARCH + query); },
        nurserySearch: function (slug) { return Axios.get(NURSURY + slug); },
    },
    featured: {
        getFeatured: function (featureId) { return Axios.get(FEATURE + featureId); },
    },
    plant: {
        getPlants: function (plantName) { return Axios.get(PLANTS + plantName); },
        requestPlants: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, verifyCsrfExists()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Axios.post(REQUEST_PLANT, data)];
                }
            });
        }); },
    },
    checkout: {
        addItems: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, verifyCsrfExists()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Axios.post(ADD_ITEMS, data)];
                }
            });
        }); },
        getCartList: function (params) {
            if (params === void 0) { params = ''; }
            return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, Axios.get(CART_CONTENTS + params)];
            }); });
        },
        clearCart: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, verifyCsrfExists()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Axios.post(CLEAR_CART)];
                }
            });
        }); },
    },
    newsLetter: {
        subscribe: function (data) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, verifyCsrfExists()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, Axios.post(NEWSLETTER_SUBSCRIBE, data)];
                }
            });
        }); },
    },
};
